import './index.css';
import { createTheme } from '@mui/material/styles';

export default createTheme({
    // Style overrides
    overrides: {
        // Button
        MuiButton: {
            root: {
                textTransform: 'none',
                height: '30px',
                borderColor: "#d2d5d9",
                background: "#e8e9eb",
                borderStyle: "solid",
                borderWidth: "1px",
                verticalAlign: "top",
                padding: "0 10px",
                overflow: "visible",
                cursor: "pointer",
                marginLeft: "5px",
                borderRadius: 'none',
                minWidth: 'none',
                '&:hover': {
                    borderColor: '#4fb4f1;'
                },
                '&:active': {
                    backgroundColor: '#cccdcf'
                }
            },
            text: {
                fontSize: '13px',
                fontWeight: 'normal',
                color: '#304461',
                position: 'relative',
                overflow: 'hidden',
                padding: 'none'
            },
            textPrimary: {
                color: '#304461'
            }
        },
        // Tooltip
        MuiTooltip: {
            tooltip: {
                backgroundColor: '#fff',
                color: '#333',
                fontSize: '12px',
                padding: '3px',
                fontFamily: 'Open Sans',
                border: '1px solid #E0E4E8',
                boxShadow: '1px 1px #F1F1F1',
            }
        },
        // Select
        MuiSelect: {
            selectMenu: {
                borderRadius: 0
            }
        },
    },

    // Default properties
    props: {
        MuiButton: {
            disableRipple: true
        },
        MuiSelect: {
            MenuProps: {
                getContentAnchorEl: null,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left'
                }
            }
        }
    },
});